// @ts-nocheck
import React, { Component } from 'react';
import { CardElement, ElementsConsumer } from '@stripe/react-stripe-js';
import { observer, inject } from "../../../../../stores/mobx-compat";

const ELEMENT_OPTIONS = {
  style: {
    base: {
      color: '#14181a',
      fontFamily: '"Inter Tight", system-ui, sans-serif',
      fontSize: '14px',
      fontSmoothing: 'antialiased',
      '::placeholder': { color: '#8a918c' },
    },
    invalid: { color: '#ea3546', iconColor: '#ea3546' },
  },
};

class InjectedCardSection extends Component {
  handleSubmit = async (e) => {
    e.preventDefault();
    const cardElement = this.props.elements.getElement(CardElement);
    const token = await this.props.stripe.createToken(cardElement);
    if (token.error) {
      this.props.store.failure(token.error.message);
      this.props.store.payments.stripeToken = {};
    } else if (token) {
      this.props.store.payments.stripeToken = token.token;
    }
    if (!this.props.store.accountStatus.account.default_source) {
      this.props.store.payments.confirmPaymentAndSubscribe();
    }
  };

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <div
          style={{
            background: 'var(--mov-paper-2)',
            border: '1px solid var(--mov-line-strong)',
            borderRadius: 10,
            padding: '12px 14px',
          }}
        >
          <CardElement options={ELEMENT_OPTIONS} />
        </div>
        <button
          type="submit"
          style={{ display: 'none' }}
          ref={(c) => { this.props.store.payments.confirmPaymentsRef = c; }}
        />
      </form>
    );
  }
}

const WrappedInjectedCardSection = inject('store')(observer(InjectedCardSection));

const InjectedCardSectionWithStripe = (props) => (
  <ElementsConsumer>
    {({ stripe, elements }) => <WrappedInjectedCardSection {...props} stripe={stripe} elements={elements} />}
  </ElementsConsumer>
);

export default InjectedCardSectionWithStripe;
